module.exports = __webpack_public_path__ + "static/img/img_6.a39d2328.jpg";